import { Action } from 'redux';

export const GLOBAL_SET_SCORE = 'SET_SCORE';
export const GLOBAL_SET_FEEDBACK = 'SET_FEEDBACK';
export const GLOBAL_SET_COMMENTS = 'SET_COMMENTS';
export const GLOBAL_SET_ERROR = 'SET_ERROR';
export const GLOBAL_RESET = 'GLOBAL_RESET';

export interface GlobalSetScore extends Action<typeof GLOBAL_SET_SCORE> {
    payload: {
        score: any[];
    };
}
export interface GlobalSetFeedback extends Action<typeof GLOBAL_SET_FEEDBACK> {
    payload: {
        feedback: string[];
    };
}
export interface GlobalSetComments extends Action<typeof GLOBAL_SET_COMMENTS> {
    payload: {
        comments: string;
    };
}
export interface GlobalSetError extends Action<typeof GLOBAL_SET_ERROR> {
    payload: {
        error: string;
    };
}

export interface GlobalReset extends Action<typeof GLOBAL_RESET> {}
